<template>
  <b-calendar
    v-model="model"
    :min="min"
    :max="max"
    :initial-date="initialDate"
    :weekday-header-format="weekdayHeaderFormat"
    :start-weekday="startWeekday"
    :date-info-fn="dateInfoFn"
    nav-button-variant="primary"
    selected-variant="primary"
    locale="en"
    value-as-date
    hide-header
    block
    class="custom-calendar"
  >
  </b-calendar>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "Calendar",
  props: {
    value: { type: [String, Date], default: new Date() },
    min: { type: [String, Date], default: null },
    max: { type: [String, Date], default: null },
    initialDate: { type: [String, Date], default: null },
    weekdayHeaderFormat: { type: String, default: "narrow" },
    startWeekday: { type: [String, Number], default: 1 },
    dateInfoFn: { type: Function, default: null }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
});
</script>

<style scoped lang="scss">
.custom-calendar {
  background-color: white;
  padding-top: 10px;
  border-radius: 7px;

  :deep(.b-calendar-inner) {
    min-width: 220px !important;
  }

  :deep(.b-calendar-grid) {
    border-width: 0;

    &:focus {
      box-shadow: none !important;
    }
  }
  :deep(.b-calendar-nav) {
    justify-content: space-between;
    margin-bottom: -32px;

    > :first-child,
    > :last-child,
    > :nth-child(3) {
      display: none;
    }
    > :nth-child(2),
    > :nth-child(4) {
      flex-grow: 0 !important;
      margin: 0 10px;
      width: 29px;
    }
  }
  :deep(.b-calendar-grid-caption) {
    font-size: 14px;
    font-weight: 600;
    color: #707070;
    margin-bottom: 15px;
  }
  :deep(.b-calendar-grid-weekdays) {
    border-bottom: none !important;

    small {
      font-size: 10px !important;
      font-weight: 600 !important;
      color: #707070 !important;
    }
  }
  :deep(.b-calendar-grid-body) {
    div.row {
      border-radius: var(--border-radius-sm) !important;
      margin-top: 8px;
      margin-bottom: 8px;

      div.col {
        cursor: default !important;
        flex-grow: 1 !important;

        &:first-child {
          span.btn {
            border-top-left-radius: var(--border-radius-sm) !important;
            border-bottom-left-radius: var(--border-radius-sm) !important;
          }
        }
        &:last-child {
          span.btn {
            border-top-right-radius: var(--border-radius-sm) !important;
            border-bottom-right-radius: var(--border-radius-sm) !important;
          }
        }
        &:not(.selected-date-range) .btn-outline-primary:hover {
          color: white !important;
        }
      }

      span.btn {
        font-size: 10px !important;
        font-weight: 400 !important;
        color: #6d6d6d !important;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 !important;
        border-radius: 0 !important;

        &.disabled {
          cursor: not-allowed !important;
        }

        &.active {
          color: white !important;
          background-color: #363abb !important;
          border-radius: var(--border-radius-sm) !important;
        }

        &:focus,
        &.focus {
          box-shadow: none !important;
        }

        &.btn-light {
          background-color: transparent;
        }
      }
    }
  }
  :deep(.b-calendar-grid-help) {
    display: none;
  }
}
</style>
